export type PromptSegment = { type: 'text' | 'field'; value: string };

const FIELD_RE = /\[([^\]]+)\]/g;

export function extractFields(text: string): string[] {
  const seen = new Set<string>();
  for (const match of text.matchAll(FIELD_RE)) seen.add(match[1]);
  return Array.from(seen);
}

export function splitPrompt(text: string): PromptSegment[] {
  const segments: PromptSegment[] = [];
  let last = 0;
  for (const match of text.matchAll(FIELD_RE)) {
    const index = match.index ?? 0;
    if (index > last) segments.push({ type: 'text', value: text.slice(last, index) });
    segments.push({ type: 'field', value: match[1] });
    last = index + match[0].length;
  }
  if (last < text.length) segments.push({ type: 'text', value: text.slice(last) });
  return segments;
}

export function fillPrompt(text: string, values: Record<string, string>): string {
  return text.replace(FIELD_RE, (full, key: string) => values[key]?.trim() || full);
}
